let port = null;
let reader = null;
let updateBatteryCallback;
let updateIdCallback;

const handleConnect = async () => {
  try {
    port = await navigator.serial.requestPort();
    console.log('Dispositivo seleccionado:', port);
    await port.open({ baudRate: 115200 });
    console.log('Puerto abierto con éxito');

    // Obtén el lector del puerto
    reader = port.readable.getReader();

    setupPrints();
  } catch (error) {
    console.error('Error al seleccionar el dispositivo o abrir el puerto:', error);
  }
};

const setupPrints = () => {
  navigator.serial.addEventListener('connect', (event) => {
    console.log('Dispositivo serial conectado:', event.target);
  });

  navigator.serial.addEventListener('disconnect', (event) => {
    console.log('Dispositivo serial desconectado:', event.target);
  });

  // Comienza a escuchar mensajes desde el dispositivo
  readMessages();
};

const readMessages = async () => {
  try {
    while (true) {
      const { value, done } = await reader.read();
      if (done) {
        console.log('La respuesta ha sido completamente recibida.');
        break;
      }

      const textDecoder = new TextDecoder();
      const textValue = textDecoder.decode(value);

      processMessage(textValue);
    }
  } catch (error) {
    console.error('Error al recibir mensajes:', error);
  }
};

const processMessage = (message) => {
  // Parsea el mensaje y extrae el porcentaje de la batería
  const batteryMatch = message.match(/Percentage of battery: (\d+\.\d+)/);
  const idMatch = message.match(/ID: (\d+)/);

  if (batteryMatch && batteryMatch[1]) {
    const batteryPercentage = parseFloat(batteryMatch[1]);
    console.log('Battery Percentage:', batteryPercentage);

    // Actualiza el componente de React con el nuevo porcentaje de batería
    if (typeof updateBatteryCallback === 'function') {
      updateBatteryCallback(batteryPercentage);
    }
  }

  if (idMatch && idMatch[1]) {
    const deviceId = parseInt(idMatch[1]);
    console.log('Device ID:', deviceId);

    if (typeof updateIdCallback === 'function') {
      updateIdCallback(deviceId);
    }
  }
};

const setUpdateBatteryCallback = (callback) => {
  updateBatteryCallback = callback;
};

const setUpdateIdCallback = (callback) => {
  updateIdCallback = callback;
};

export {
  handleConnect,
  setupPrints,
  readMessages,
  setUpdateBatteryCallback,
  setUpdateIdCallback,
};